import axios from "axios";
import { queryParams } from "../../../utils/queryParams";

const api = axios.create({ baseURL: queryParams.apiVersion + "" });

const BASE = "pages/sales_revenue/products_sales_chart";

export const productSalesApi = {
  getChart(body) {
    return api.post(`${BASE}/values`, body);
  },

  getFilters(params) {
    return api.get(`${BASE}/filters`, { params });
  },

  getRevenueCategories(body) {
    return api.post(`${BASE}/get_revenue_categories`, body);
  }
};
